// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomProductPopup_CustomProductPopup__nJ3u8 {
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 1400;
    height: 100%;
    width: 100%;
    background-color: rgb(0 0 0 / 0.2);
    display: flex;
    align-items: center;
    justify-content: center
}

.CustomProductPopup_CustomProductPopup__nJ3u8 .CustomProductPopup_contents__b5DvA {
    position: relative;
    width: 100%;
    max-width: 80vw;
    border-radius: 0.5rem;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    display: flex;
    flex-direction: column
}

.CustomProductPopup_CustomProductPopup__nJ3u8 .CustomProductPopup_contents__b5DvA .CustomProductPopup_top__Dd5qo {
    position: relative;
    display: flex;
    justify-content: space-between;
    padding: 1rem;
    border-bottom-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(209 213 219 / var(--tw-border-opacity, 1))
}
.CustomProductPopup_CustomProductPopup__nJ3u8 .CustomProductPopup_contents__b5DvA .CustomProductPopup_top__Dd5qo .CustomProductPopup_closeButton__E7fXs {
    display: flex;
    height: 1.5rem;
    width: 1.5rem;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    border-radius: 9999px;
    background-color: rgb(0 0 0 / 0.1);
    position: absolute;
    top: -0.75rem;
    right: -0.75rem
}

.CustomProductPopup_CustomProductPopup__nJ3u8 .CustomProductPopup_contents__b5DvA .CustomProductPopup_top__Dd5qo .CustomProductPopup_left__hWG11 {
    margin-right: 1rem;
    flex: 1 1;
    position: relative
}

.CustomProductPopup_CustomProductPopup__nJ3u8 .CustomProductPopup_contents__b5DvA .CustomProductPopup_body__lxcq6 {
}
.CustomProductPopup_CustomProductPopup__nJ3u8 .CustomProductPopup_contents__b5DvA .CustomProductPopup_body__lxcq6 .CustomProductPopup_products__wdvbM {
    display: grid;
    height: 70vh;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.5rem;
    overflow-y: auto;
    padding: 1rem;
    grid-template-rows: repeat(auto-fill, 95px)
}
.CustomProductPopup_CustomProductPopup__nJ3u8 .CustomProductPopup_contents__b5DvA .CustomProductPopup_body__lxcq6 .CustomProductPopup_products__wdvbM .CustomProductPopup_productImage__86h8A {
    height: 100%;
    flex: 0 0 20%;
    overflow: hidden;
    padding-right: 0.5rem
}
.CustomProductPopup_CustomProductPopup__nJ3u8 .CustomProductPopup_contents__b5DvA .CustomProductPopup_body__lxcq6 .CustomProductPopup_products__wdvbM .CustomProductPopup_productImage__86h8A img {
    height: 100%;
    width: 100%;
    object-fit: contain;
    object-position: center
}

.CustomProductPopup_BulkSkuPopup__9zVir {
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 50;
    height: 100%;
    width: 100%;
    background-color: rgb(0 0 0 / 0.2);
    display: flex;
    align-items: center;
    justify-content: center
}
.CustomProductPopup_BulkSkuPopup__9zVir .CustomProductPopup_contents__b5DvA {
    position: relative;
    width: 100%;
    max-width: 70vw;
    border-radius: 0.5rem;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    display: flex;
    flex-direction: column
}

.CustomProductPopup_BulkSkuPopup__9zVir .CustomProductPopup_BulkSkuPopup__header__Lt3BN {
    position: relative;
    display: flex;
    justify-content: space-between;
    padding: 1rem;
    border-bottom-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(209 213 219 / var(--tw-border-opacity, 1))
}
.CustomProductPopup_BulkSkuPopup__9zVir .CustomProductPopup_BulkSkuPopup__header__Lt3BN .CustomProductPopup_BulkSkuPopup__closeBtn__rOJuX {
    display: flex;
    height: 1.5rem;
    width: 1.5rem;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    border-radius: 9999px;
    background-color: rgb(0 0 0 / 0.1);
    position: absolute;
    top: -0.75rem;
    right: -0.75rem
}
.CustomProductPopup_BulkSkuPopup__9zVir .CustomProductPopup_BulkSkuPopup__body__sZT5k {
    display: flex;
    flex-direction: column
}
.CustomProductPopup_BulkSkuPopup__9zVir .CustomProductPopup_BulkSkuPopup__body__sZT5k textarea {
    height: 60vh;
    width: 100%;
    padding: 1rem;
    resize: none;
    outline: none
}
.CustomProductPopup_BulkSkuPopup__9zVir .CustomProductPopup_BulkSkuPopup__footer__iOnih {
    display: flex;
    justify-content: flex-end;
    padding: 1rem
}
.CustomProductPopup_BulkSkuPopup__9zVir .CustomProductPopup_BulkSkuPopup__footer__iOnih h3 {
    font-size: 1.25rem;
    line-height: 1.75rem;
    font-weight: 600
}
.CustomProductPopup_BulkSkuPopup__9zVir .CustomProductPopup_BulkSkuPopup__footer__iOnih ul {
    display: flex;
    gap: 1rem
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomProductPopup/CustomProductPopup.module.css"],"names":[],"mappings":"AACI;IAAA,eAA4D;IAA5D,QAA4D;IAA5D,SAA4D;IAA5D,aAA4D;IAA5D,YAA4D;IAA5D,WAA4D;IAA5D,kCAA4D;IAC5D,aAAuC;IAAvC,mBAAuC;IAAvC;AAD4D;;AAK5D;IAAA,kBAAiE;IAAjE,WAAiE;IAAjE,eAAiE;IAAjE,qBAAiE;IAAjE,kBAAiE;IAAjE,4DAAiE;IAAjE,+EAAiE;IAAjE,mGAAiE;IAAjE,uGAAiE;IACjE,aAAoB;IAApB;AADiE;;AAKjE;IAAA,kBAAwC;IAAxC,aAAwC;IAAxC,8BAAwC;IAAxC,aAAwC;IACxC,wBAA+B;IAA/B,sBAA+B;IAA/B;AADwC;AAIxC;IAAA,aAA2E;IAA3E,cAA2E;IAA3E,aAA2E;IAA3E,eAA2E;IAA3E,mBAA2E;IAA3E,uBAA2E;IAA3E,qBAA2E;IAC3E,kCAAkB;IAClB,kBAA+B;IAA/B,aAA+B;IAA/B;AAF2E;;AAM3E;IAAA,kBAAkB;IAAlB,SAAkB;IAClB;AADkB;;AAItB;AACA;AAEI;IAAA,aAA0D;IAA1D,YAA0D;IAA1D,gDAA0D;IAA1D,WAA0D;IAA1D,gBAA0D;IAA1D,aAA0D;IAC1D;AAD0D;AAI1D;IAAA,YAAiD;IAAjD,aAAiD;IAAjD,gBAAiD;IAAjD;AAAiD;AAGjD;IAAA,YAAiD;IAAjD,WAAiD;IAAjD,mBAAiD;IAAjD;AAAiD;;AAIjD;IAAA,eAAwD;IAAxD,QAAwD;IAAxD,SAAwD;IAAxD,WAAwD;IAAxD,YAAwD;IAAxD,WAAwD;IAAxD,kCAAwD;IACxD,aAAuC;IAAvC,mBAAuC;IAAvC;AADwD;AAIxD;IAAA,kBAAiE;IAAjE,WAAiE;IAAjE,eAAiE;IAAjE,qBAAiE;IAAjE,kBAAiE;IAAjE,4DAAiE;IAAjE,+EAAiE;IAAjE,mGAAiE;IAAjE,uGAAiE;IACjE,aAAoB;IAApB;AADiE;;AAKjE;IAAA,kBAAwC;IAAxC,aAAwC;IAAxC,8BAAwC;IAAxC,aAAwC;IACxC,wBAA+B;IAA/B,sBAA+B;IAA/B;AADwC;AAIxC;IAAA,aAA2E;IAA3E,cAA2E;IAA3E,aAA2E;IAA3E,eAA2E;IAA3E,mBAA2E;IAA3E,uBAA2E;IAA3E,qBAA2E;IAC3E,kCAAkB;IAClB,kBAA+B;IAA/B,aAA+B;IAA/B;AAF2E;AAK3E;IAAA,aAAoB;IAApB;AAAoB;AAGpB;IAAA,YAA0B;IAA1B,WAA0B;IAA1B,aAA0B;IAC1B,YAAkB;IAClB;AAF0B;AAK1B;IAAA,aAA2B;IAA3B,yBAA2B;IAA3B;AAA2B;AAG3B;IAAA,kBAA4B;IAA5B,oBAA4B;IAA5B;AAA4B;AAG5B;IAAA,aAAiB;IAAjB;AAAiB","sourcesContent":[".CustomProductPopup {\n    @apply fixed top-0 left-0 w-full h-full z-[1400] bg-black/20;\n    @apply flex justify-center items-center;\n}\n\n.CustomProductPopup .contents {\n    @apply relative w-full max-w-[80vw] bg-white rounded-lg shadow-lg;\n    @apply flex flex-col;\n}\n\n.CustomProductPopup .contents .top {\n    @apply flex justify-between p-4 relative;\n    @apply border-b border-gray-300;\n}\n.CustomProductPopup .contents .top .closeButton {\n    @apply flex items-center justify-center w-6 h-6 rounded-full cursor-pointer;\n    @apply bg-black/10;\n    @apply absolute -top-3 -right-3;\n}\n\n.CustomProductPopup .contents .top .left {\n    @apply flex-1 mr-4;\n    @apply relative;\n}\n\n.CustomProductPopup .contents .body {\n}\n.CustomProductPopup .contents .body .products {\n    @apply h-[70vh] p-4 overflow-y-auto grid grid-cols-3 gap-2;\n    grid-template-rows: repeat(auto-fill, 95px);\n}\n.CustomProductPopup .contents .body .products .productImage {\n    @apply flex-[0_0_20%] pr-2 h-full overflow-hidden;\n}\n.CustomProductPopup .contents .body .products .productImage img {\n    @apply w-full h-full object-contain object-center;\n}\n\n.BulkSkuPopup {\n    @apply fixed top-0 left-0 w-full h-full z-50 bg-black/20;\n    @apply flex justify-center items-center;\n}\n.BulkSkuPopup .contents {\n    @apply relative w-full max-w-[70vw] bg-white rounded-lg shadow-lg;\n    @apply flex flex-col;\n}\n\n.BulkSkuPopup .BulkSkuPopup__header {\n    @apply flex justify-between p-4 relative;\n    @apply border-b border-gray-300;\n}\n.BulkSkuPopup .BulkSkuPopup__header .BulkSkuPopup__closeBtn {\n    @apply flex items-center justify-center w-6 h-6 rounded-full cursor-pointer;\n    @apply bg-black/10;\n    @apply absolute -top-3 -right-3;\n}\n.BulkSkuPopup .BulkSkuPopup__body {\n    @apply flex flex-col;\n}\n.BulkSkuPopup .BulkSkuPopup__body textarea {\n    @apply w-full h-[60vh] p-4;\n    @apply resize-none;\n    outline: none;\n}\n.BulkSkuPopup .BulkSkuPopup__footer {\n    @apply flex justify-end p-4;\n}\n.BulkSkuPopup .BulkSkuPopup__footer h3 {\n    @apply text-xl font-semibold;\n}\n.BulkSkuPopup .BulkSkuPopup__footer ul {\n    @apply flex gap-4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"CustomProductPopup": `CustomProductPopup_CustomProductPopup__nJ3u8`,
	"contents": `CustomProductPopup_contents__b5DvA`,
	"top": `CustomProductPopup_top__Dd5qo`,
	"closeButton": `CustomProductPopup_closeButton__E7fXs`,
	"left": `CustomProductPopup_left__hWG11`,
	"body": `CustomProductPopup_body__lxcq6`,
	"products": `CustomProductPopup_products__wdvbM`,
	"productImage": `CustomProductPopup_productImage__86h8A`,
	"BulkSkuPopup": `CustomProductPopup_BulkSkuPopup__9zVir`,
	"BulkSkuPopup__header": `CustomProductPopup_BulkSkuPopup__header__Lt3BN`,
	"BulkSkuPopup__closeBtn": `CustomProductPopup_BulkSkuPopup__closeBtn__rOJuX`,
	"BulkSkuPopup__body": `CustomProductPopup_BulkSkuPopup__body__sZT5k`,
	"BulkSkuPopup__footer": `CustomProductPopup_BulkSkuPopup__footer__iOnih`
};
export default ___CSS_LOADER_EXPORT___;
